import useFormatterPrice from '@/src/utils/formatter-price';
import { IoMdPricetag } from 'react-icons/io';
import { MdGavel } from 'react-icons/md';
import useCurrencyConversion from '@/src/utils/useCurrencyConversion';
import getAdPrice from '@/src/utils/getAdPrice';
import { useSelector } from 'react-redux';
import { RootState } from '@/src/redux/store';
import useShowPrice from '@/src/utils/useShowPrice';
import BlurredPrice from '@/src/app/[locale]/item/[id]/components/BlurredPrice';
import useIfDefaultCurrency from '@/src/utils/useIfDefaultCurrency';
import useHostMatch from '@/src/utils/useHostMatch';
export default function PriceTag({ ad }: { ad: any }) {
  const initPrice = getAdPrice(ad);
  const showPrice = useShowPrice(ad);
  let isAuction = 'bg-brand text-black';
  if (ad?.ad_auction?.time_end_extended) {
    isAuction =
      new Date(ad.ad_auction.time_end_extended).getTime() < new Date().getTime()
        ? 'bg-brand-alt text-white'
        : 'bg-brand text-black';
  }
  const auctionPrice: number = useSelector((state: RootState) => {
    if (!ad || !ad.hasOwnProperty('ad_auction') || !ad.ad_auction) return 0;
    const auction = state.auctions[ad.ad_auction.id];
    return auction ? Number(auction.amount) : 0;
  });
  const price = Math.max(initPrice, auctionPrice);

  const convert = useCurrencyConversion();
  const isDefaultCurrency = useIfDefaultCurrency();
  const formatterPrice = useFormatterPrice();
  const isRawDomain = useHostMatch('atsauksjon.no');

  return (
    <div
      className={`items-center absolute right-0 top-12 flex gap-1 rounded-l leading-tight ${isAuction} z-20 px-2 py-1 font-bold uppercase`}
    >
      <span className='text-md'>{ad.ad_auction ? (
        <span style={{ transform: 'rotateY(180deg)' }}>
          <MdGavel />
        </span>
      ) : (
        <IoMdPricetag />
      )}</span>
      {showPrice ? (
        isRawDomain || isDefaultCurrency
          ? formatterPrice(price) 
          : convert(price)
            ? formatterPrice(convert(price)) 
            : ''
      ) : (
        <BlurredPrice />
      )}
    </div>
  );
}
